export default __webpack_public_path__ + "static/media/news19.5bc8fb36.jpg";